export type PriceInfo = {
  amount: number;
  currency: string;
  interval: "month" | "year";
};

export type PricingResponse = {
  monthly: PriceInfo;
  annual: PriceInfo;
  earlyAdopterOfferOpen: boolean;
};

export function isValidPricing(value: unknown): value is PricingResponse {
  if (!value || typeof value !== "object") return false;
  const pricing = value as Partial<PricingResponse>;
  return Boolean(
    pricing.monthly &&
      pricing.annual &&
      pricing.monthly.amount > 0 &&
      pricing.annual.amount > 0 &&
      pricing.monthly.interval === "month" &&
      pricing.annual.interval === "year" &&
      pricing.monthly.currency === pricing.annual.currency,
  );
}
